/* global getData */
import { createRouter, createWebHistory } from "vue-router";
import axios from "axios";

import HomeView from "../views/HomeView.vue";
import LoginView from "@/views/LoginView.vue";
import { saveReturnPath } from "@/composables/useAuthReturn";
import SignupView from "@/views/SignupView.vue";
import EduManagementView from "@/views/EduManagementView.vue";
import EduRegisterView from "@/views/EduRegisterView.vue";
import EduRegisterConfirmView from "@/views/EduRegisterConfirmView.vue";
import MemberProfileView from "@/views/MemberProfileView.vue";
import EduRegisterDone from "@/views/EduRegisterDoneView.vue";
import PolicyView from "@/views/PolicyView.vue";
import naverLoginCheck from "@/components/naverLoginCheckComponent.vue";
import appleLoginCheck from "@/components/appleLoginCheckComponent.vue";
import alimtalkComponent from "@/components/alimtalkComponent.vue";
import logoutView from "@/views/logoutView.vue";
import testComponent from "@/components/test.vue";
import myCancelList from "@/views/cancelListView.vue";
import RegisteredMembersPage2 from "@/pages/management/RegisteredMembersPage2.vue"; // 컨퍼런스 등록 회원 목록2
import QnaListPage from "@/pages/management/QnaListPage.vue";

import qnaView from "@/views/qnaView.vue";
import barcodeView from "@/views/BarcodeView.vue";
import barcodeVerifyView from "@/views/barcodeVerifyView.vue";
import store from "@/store";
import conferenceListView from "@/views/conferenceListView.vue";
import conferenceDetailView from "@/views/conferenceDetailView.vue";
import NewconferenceListView from "@/views/new/conferenceListView.vue";

import onlineMeeting from "@/views/zoomLinkView.vue";

import contentsMainView from "@/views/contentsMainView.vue";
import contentsDetailView from "@/views/contentsDetailView.vue";
import contentsAiView from "@/views/contentsAiView.vue";

import myPageView from "@/views/myPageView.vue";
import myMainPageNew from "@/pages/myPage/myMainPageNew.vue";
import myListPage from "@/pages/myPage/myListPage.vue";
import myListDetailPage from "@/pages/myPage/myListDetailPage.vue";
import myListDetailPage2 from "@/pages/myPage/myListDetailPage2.vue";
import postPage from "@/pages/myPage/myPostPage.vue";

import myCartPage2 from "@/pages/myPage/myCartPage2.vue";
import myOrderPage2 from "@/pages/myPage/myOrderPage2.vue";
import myOrderPage3 from "@/pages/myPage/myOrderPage3.vue";
import myOrderDonePage from "@/pages/myPage/myOrderDonePage.vue";
import myContentsPage from "@/pages/myPage/myContentsPage.vue";
import myContentsDetailPage from "@/pages/myPage/myContentsDetailPage.vue";
import downloadHistory from "@/pages/myPage/downloadHistory.vue";
import reviewPage from "@/pages/myPage/myReviewPage.vue";

import introView from "@/views/introView.vue";

import communityView from "@/views/communityView.vue";
import communityListPage from "@/pages/community/communityListPage.vue";
import communityWritePage from "@/pages/community/communityWritePage.vue";
import communityViewPage from "@/pages/community/communityViewPage.vue";

import board from "@/views/board.vue";
import boardListPage from "@/pages/board/boardListPage.vue";
import boardWritePage from "@/pages/board/boardWritePage.vue";
import boardViewPage from "@/pages/board/boardViewPage.vue";

import helpView from "@/views/helpView.vue";
import appMain from "@/pages/AppMainPage.vue";
import appHana1 from "@/pages/AppHana1Page.vue";
import appHana2 from "@/pages/AppHana2Page.vue";
import NotFoundView from "@/views/NotFoundView.vue";

import contentsHanaView from "@/views/contentsHanaView.vue";

const routes = [
  { path: "/home", name: "home", component: HomeView },
  {
    path: "/",
    alias: "/main",
    name: "main",
    component: () => import("@/views/new/mainView.vue"),
    children: [
      {
        path: "",
        name: "main",
        component: () => import("@/pages/new/mainPage.vue"),
      },
    ],
  },
  // 컨퍼런스 목록 페이지
  { path: "/conf", name: "eduList", component: NewconferenceListView },
  // 컨퍼런스 상세 페이지
  { path: "/:idx", name: "conferenceList", component: conferenceDetailView },
  // 컨퍼런스 등록 페이지
  {
    path: "/register",
    name: "eduRegister",
    component: EduRegisterView,
    props: true,
  },
  // 컨퍼런스 등록 페이지
  {
    path: "/register/:idx",
    name: "eduRegister2",
    component: EduRegisterView,
    props: true,
  },
  // 컨퍼런스 등록 페이지
  {
    path: "/register_pay/:idx",
    name: "eduRegisterConfirm",
    component: EduRegisterConfirmView,
    props: true,
  },
  // 컨퍼런스 등록 완료 페이지
  {
    path: "/register_done",
    name: "eduRegisterDone",
    component: EduRegisterDone,
  },

  {
    path: "/app/:idx",
    name: "conferenceListApp",
    component: conferenceListView,
  },
  { path: "/hana", name: "hanaeduList", component: conferenceListView },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    // 이미 로그인했으면 메인으로 보낸다 (전역 가드가 /api/account/check 결과를 store 에 먼저 넣어 둔다)
    beforeEnter: () => {
      if (store.state.account.id) return { path: "/" };
    },
  },
  { path: "/help_find_2", name: "helpPage", component: helpView },
  { path: "/help_find", name: "helpPage", component: helpView },
  { path: "/app/help_find", name: "helpPageApp", component: helpView },
  { path: "/signup", name: "signup", component: SignupView },
  { path: "/signup/app", name: "signup_app", component: SignupView },
  { path: "/signup_sns", name: "signup_sns", component: SignupView },
  {
    path: "/management",
    name: "eduManagement",
    component: EduManagementView,
    meta: { requiresAuth: true },
  },
  {
    path: "/management/:token",
    name: "eduManagementToken",
    component: EduManagementView,
    meta: { requiresAuth: true },
  },

  {
    path: "/app/register",
    name: "eduRegisterApp",
    component: EduRegisterView,
    props: true,
  },
  {
    path: "/app/register/:idx",
    name: "eduRegister2App",
    component: EduRegisterView,
    props: true,
  },
  {
    path: "/app/register_pay/:idx",
    name: "eduRegisterConfirmApp",
    component: EduRegisterConfirmView,
    props: true,
  },
  {
    path: "/app/register_done",
    name: "eduRegisterDoneApp",
    component: EduRegisterDone,
  },

  { path: "/test", name: "test", component: testComponent },

  // 회원 탈퇴
  {
    path: "/withdrawal",
    name: "withdrawal",
    component: () => import("@/views/withdrawalView.vue"),
  },
  {
    path: "/app/withdrawal",
    name: "withdrawalApp",
    component: () => import("@/views/withdrawalView.vue"),
  },

  // naver login callback url
  {
    path: "/naverLoginCheck",
    name: "naverLoginCheck",
    component: naverLoginCheck,
  },
  {
    path: "/appleLoginCheck",
    name: "appleLoginCheck",
    component: appleLoginCheck,
  },

  {
    path: "/alimtalk_test",
    name: "alimtalk_test",
    component: alimtalkComponent,
  },
  { path: "/myCancelList", name: "my_cancel_list", component: myCancelList }, // 취소 신청 내역
  {
    path: "/management2",
    name: "eduManagement2",
    component: RegisteredMembersPage2,
  }, // 컨퍼런스 등록 회원 목록2
  { path: "/qnalist", name: "qnalist", component: QnaListPage },

  {
    path: "/policy/info",
    name: "PolicyInfo",
    component: PolicyView,
    props: { currentComponent: "PolicyInfoPage" },
  },
  {
    path: "/policy/guide",
    name: "PolicyGuide",
    component: PolicyView,
    props: { currentComponent: "PolicyGuidePage" },
  },

  {
    path: "/profile",
    name: "memberProfile",
    component: MemberProfileView,
    props: { currentComponent: "MemberProfilePage" },
    meta: { requiresAuth: true },
  },
  {
    // 웹에서 사용 중
    path: "/profile/confList",
    name: "memberProfileConference",
    component: MemberProfileView,
    props: { currentComponent: "MemberProfileConfPage" },
    meta: { requiresAuth: true },
  },
  {
    // 앱 에서 '컨퍼런스' 탭에서 사용 중
    path: "/profile/confList/app",
    name: "memberProfileConferenceApp",
    component: MemberProfileView,
    props: { currentComponent: "MemberProfileConfPage" },
    meta: { requiresAuth: true },
  },

  {
    // 앱 에서 '내정보' 탭에서 사용 중
    path: "/profile/confList/app2",
    name: "memberProfileConferenceApp2",
    component: MemberProfileView,
    props: { currentComponent: "MemberProfileConfPage" },
    meta: { requiresAuth: true },
  },

  {
    path: "/profile/confList/test",
    name: "memberProfileConferenceTest",
    component: MemberProfileView,
    props: { currentComponent: "MemberProfileConfPageTest" },
  },

  { path: "/logout", name: "logout", component: logoutView }, // 로그아웃
  { path: "/qna", name: "qna", component: qnaView },

  { path: "/barcode/:idx", name: "barcode", component: barcodeView },
  {
    path: "/barcodeVerify",
    name: "barcodeVerify",
    component: barcodeVerifyView,
  },

  { path: "/online/:idx", name: "onlineMeeting", component: onlineMeeting },

  // 콘텐츠몰 (하나 큐브)
  {
    path: "/mall",
    component: () => import("@/views/new/mainView.vue"),
    // 검색 링크(/mall?search=...)는 검색 결과 페이지로 보낸다
    beforeEnter: (to) => {
      if (to.query.search) return { path: "/mall/search", query: to.query };
    },
    children: [
      {
        path: "",
        name: "contentsMain",
        component: () => import("@/pages/new/mall/mallIndexPage.vue"),
      },
    ],
  },
  {
    // 구 콘텐츠몰 홈
    path: "/mall/home",
    name: "contentsMallHome",
    component: contentsMainView,
  },

  // 카테고리 전체 대상 검색 결과
  {
    path: "/mall/search",
    name: "contentsSearch",
    component: contentsMainView,
    props: (route) => ({ searchQuery: route.query.search }),
  },
  {
    path: "/mall/:category/:subcategory?",
    name: "contentsCategory",
    component: contentsMainView,
  },
  {
    // path: '/mall/view/:contentId',
    path: "/mall/view/:itemId",
    name: "contentsDetail",
    component: contentsDetailView,
  },
  {
    // 챗봇 자료 링크: 영상은 영상 링크로, 파일·상품은 상세로 보내는 중간 페이지
    path: "/mall/open/:id",
    name: "contentOpen",
    component: () => import("@/pages/contentsMall/contentOpenPage.vue"),
  },
  {
    path: "/mall/ai-search",
    name: "contentsAi",
    component: contentsAiView,
  },
  {
    path: "/mall/ai-result",
    name: "contentsAiResult",
    component: contentsAiView,
  },
  {
    path: "/mall/hana",
    name: "contentsHana",
    component: contentsHanaView,
  },
  // { path: '/mall/view/:itemId', name: 'itemDetail', component: contentsDetailView },

  // 마이페이지
  {
    path: "/mypage",
    name: "mypage",
    component: myPageView,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "myMain",
        // component: myMainPage,
        component: myMainPageNew,
      },
      {
        path: "list",
        name: "myList",
        component: myListPage,
        meta: { pageType: "purchase" },
      },
      {
        path: "paymentList",
        name: "myPayment",
        component: myListPage,
        meta: { pageType: "payment" },
      },
      {
        path: "list/:id",
        name: "myListDetail",
        component: myListDetailPage,
      },
      {
        path: "detail/:id",
        name: "myOrderDetail",
        component: myListDetailPage2,
      },
      {
        path: "cart",
        name: "cart",
        component: myCartPage2,
        // component: myCartPage,
      },

      {
        // 카티고리 2
        path: "cart2",
        name: "cart2",
        component: myCartPage2,
      },
      // 일반적 결제
      {
        path: "order",
        name: "order",
        component: myOrderPage3,
      },
      {
        path: "order2",
        name: "order2",
        component: myOrderPage3,
      },
      {
        path: "order/:paymentStatus",
        name: "orderPaymentStatus",
        component: myOrderPage2,
      },

      {
        path: "order_done/:oid",
        name: "orderDone",
        component: myOrderDonePage,
      },
      {
        path: "contentsBox",
        name: "contentsBox",
        component: myContentsPage,
      },
      {
        path: "contentsBox/:ocid",
        name: "contentsBoxDetail",
        component: myContentsDetailPage,
      },
      {
        path: "downloadHistory",
        name: "downloadHistory",
        component: downloadHistory,
      },
      {
        path: "review",
        name: "review",
        component: reviewPage,
      },
      {
        path: "post",
        name: "post",
        component: postPage,
      },
    ],
  },

  // 소개
  { path: "/introduce", redirect: "/introduce/1" },
  { path: "/introduce/:category", name: "intros", component: introView },

  // 커뮤니티
  {
    path: "/community",
    name: "community",
    redirect: "/community/1",
    component: communityView,
    children: [
      {
        path: ":boardId",
        name: "communityList",
        component: communityListPage,
      },
      {
        path: "write/:postId?",
        name: "communityWrite",
        component: communityWritePage,
      },
      {
        path: ":boardId/:postId",
        name: "communityView",
        component: communityViewPage,
      },
    ],
  },

  // 커뮤니티
  {
    path: "/board",
    name: "board",
    redirect: "/board/5",
    component: board,
    children: [
      {
        path: ":boardId",
        name: "boardList",
        component: boardListPage,
      },
      {
        path: "write/:boardId/:postId?",
        name: "boardWrite",
        component: boardWritePage,
      },
      {
        path: ":boardId/:postId",
        name: "boardView",
        component: boardViewPage,
      },
    ],
  },

  { path: "/app_main", name: "app_main", component: appMain },
  { path: "/app_hana1", name: "app_hana1", component: appHana1 },
  { path: "/app_hana2", name: "app_hana2", component: appHana2 },

  // tokenGateway
  {
    path: "/tokenGateway",
    name: "tokenGateway",
    component: () => import("@/components/tokenGateway.vue"),
  },

  // 게임
  {
    path: "/game",
    name: "game",
    component: () => import("@/views/gameView.vue"),
    children: [
      {
        path: "",
        name: "gameHome",
        component: () => import("@/pages/game/HomePage.vue"),
      },

      {
        path: "play",
        name: "gamePlay",
        component: () => import("@/pages/game/PlayPage.vue"),
      },

      {
        path: "end",
        name: "gameEnd",
        component: () => import("@/pages/game/EndPage.vue"),
      },
    ],
  },

  // 하나 바이블
  {
    path: "/hana-bible",
    name: "hana-bible",
    component: () => import("@/views/new/mainView.vue"),
    children: [
      {
        path: "",
        name: "hana-bible-main",
        component: () => import("@/pages/new/hana/hanaBiblePage.vue"),
      },
      {
        path: "course",
        name: "hana-bible-course",
        component: () => import("@/pages/new/hana/hanaCoursePage.vue"),
      },
      {
        path: "board",
        name: "hana-bible-board",
        component: () => import("@/pages/new/hana/hanaBoard.vue"),
      },
      {
        path: "board/:boardId/:postId",
        name: "hana-bible-board-view",
        component: () => import("@/pages/new/hana/hanaBoardView.vue"),
      },
    ],
  },

  // 하나 브릿지
  {
    path: "/hana-bridge",
    name: "hana-bridge",
    component: () => import("@/views/new/mainView.vue"),
    children: [
      {
        path: "",
        name: "hana-bridge-main",
        component: () => import("@/pages/new/hana/hanaBridgePage.vue"),
      },
    ],
  },

  // 하나 리본
  {
    path: "/hana-ribbon",
    name: "hana-ribbon",
    component: () => import("@/views/new/mainView.vue"),
    children: [
      {
        path: "",
        name: "hana-ribbon-main",
        component: () => import("@/pages/new/hana/hanaRibbonPage.vue"),
      },
    ],
  },

  // 성경학교 소개
  {
    path: "/bible-school",
    name: "bible-school",
    component: () => import("@/views/new/mainView.vue"),
    children: [
      {
        path: "",
        name: "bible-school-main",
        component: () => import("@/pages/new/bibleSchoolPage.vue"),
      },
    ],
  },

  // 사역지원
  {
    path: "/ministry-support",
    name: "ministry-support",
    component: () => import("@/views/new/mainView.vue"),
    children: [
      {
        path: "",
        name: "ministry-support-main",
        component: () => import("@/pages/MinistrySupportPage.vue"),
      },
    ],
  },

  // 404
  { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFoundView },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const target = document.querySelector(to.hash);
          if (target) {
            resolve({
              el: to.hash,
              behavior: "smooth",
            });
          } else {
            resolve({ top: 0, left: 0 });
          }
        }, 300);
      });
    }

    return { top: 0, left: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  // 이전 페이지 체크
  // alert(from.fullPath);

  localStorage.setItem("prevPath", from.fullPath);
  localStorage.setItem("prevPathName", from.name);

  // 회원가입·로그인 화면으로 들어가면, 마친 뒤 돌아올 원래 페이지를 기억한다
  if (["login", "signup", "signup_sns"].includes(to.name) && from.name) {
    saveReturnPath(from.fullPath);
  }

  // const testToken = localStorage.getItem('authorization');
  // alert(`router token : ${testToken}`);

  // get parameter
  // const query = to.query;
  const queryToken = to.params.token;
  if (queryToken !== undefined) {
    const getToken = atob(queryToken);
    localStorage.setItem("authorization", getToken);
  }

  // 앱 관련 게이트웨이 페이지
  // alert(to.name);
  // alert(from.name);

  // console.log(to);
  // console.log(from);
  /*if( to.name == 'memberProfileConferenceApp' && from.name != 'tokenGateway'){
    next({ name: 'tokenGateway' });
  }*/

  // TODO: 로그인 여부 확인
  // 라우터 가드
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // const testAlert = localStorage.getItem('authorization');
    const { data } = await axios.get("/api/account/check");

    // alert(`data.err_code : ${data.err_code}`);
    // alert(`data.contents : ${data.contents}`);
    if (data.err_code === 0) {
      if (data.contents === null) {
        alert("로그인 후 이용 가능 합니다.");
        if (isAppRoute(to.name)) {
          getData.postMessage("login");
          // 앱이 로그인 처리 완료 후 다시 라우팅
          return;
        } else {
          // 웹은 인덱스 페이지로 리다이렉트
          return next({ path: "/" });
        }
      }
      const idx = data.contents.member_idx;
      store.commit("setAccount", idx || 0);
      localStorage.setItem(
        "authorization",
        data.contents.token.body.accessToken,
      );
      const res = getMember(idx);
      if (res) {
        return next();
      } else {
        alert("로그인 후 이용 가능 합니다.");
        if (isAppRoute(to.name)) {
          getData.postMessage("login");
          // 앱이 로그인 처리 완료 후 다시 라우팅
          return;
        } else {
          // 웹은 인덱스 페이지로 리다이렉트
          return next({ path: "/" });
        }
      }
    } else if (data.err_code === 401) {
      // 로그아웃 처리
      localStorage.removeItem("authorization");
      store.commit("setAccount", 0);
      store.commit("setLevel", 0);
      store.commit("setUid", "");

      alert("로그인 후 이용 가능 합니다.");

      if (isAppRoute(to.name)) {
        getData.postMessage("login");
        // 앱이 로그인 처리 완료 후 다시 라우팅
        return;
      } else {
        // 웹은 인덱스 페이지로 리다이렉트
        return next({ path: "/" });
      }
    } else {
      // 로그아웃 처리
      alert("로그인 후 이용 가능 합니다.");
      if (isAppRoute(to.name)) {
        getData.postMessage("login");
        // 앱이 로그인 처리 완료 후 다시 라우팅
        return;
      } else {
        // 웹은 인덱스 페이지로 리다이렉트
        return next({ path: "/" });
      }
    }
    // next();
  } else {
    const authorization = localStorage.getItem("authorization");
    // if (authorization !== null && authorization !== '' && authorization !== 'undefined') {
    if (
      authorization !== null &&
      authorization !== "" &&
      authorization !== "undefined"
    ) {
      const { data } = await axios.get("/api/account/check");
      // alert(data.err_msg);
      if (data.err_code === 0) {
        const idx = data.contents.member_idx;
        // alert(idx);
        store.commit("setAccount", idx || 0);
        // alert(data.contents.token.body.accessToken);
        localStorage.setItem(
          "authorization",
          data.contents.token.body.accessToken,
        );
        const res = getMember(idx);
        if (res) {
          return next();
        }
        // next();
      } else if (data.err_code === 401) {
        localStorage.removeItem("authorization");

        if (
          to.name == "memberProfileConferenceApp" ||
          to.name == "memberProfileConferenceApp2"
        ) {
          return next({ path: "/app_main" });
        } else if (isAppRoute(to.name)) {
          // 앱 전용 라우트는 통과
          return next();
        } else {
          // 웹 라우트: 로그아웃 처리 후 계속 진행
          store.commit("setAccount", 0);
          store.commit("setLevel", 0);
          store.commit("setUid", "");
          // 인덱스로 리다이렉트하지 않고 진행 (공개 페이지 허용)
        }
      }
    }
    return next();
  }
});

const getMember = async (idx) => {
  if (idx) {
    await axios.get(`/api/member/${idx}`).then(({ data }) => {
      if (data.err_code === 0) {
        store.commit("setLevel", data.contents.mlevel);
        store.commit("setUid", data.contents.uid);
        return true;
      } else {
        return false;
      }
    });
  }
};

// 앱 라우트 확인 헬퍼 함수
const isAppRoute = (routeName) => {
  const appRoutes = [
    "memberProfileConferenceApp",
    "memberProfileConferenceApp2",
    "app_main",
    "signup_app",
    "eduRegisterApp",
    "eduRegister2App",
    "eduRegisterConfirmApp",
    "eduRegisterDoneApp",
    "withdrawalApp",
    "helpPageApp",
    "app_hana1",
    "app_hana2",
  ];
  return appRoutes.includes(routeName);
};

export default router;
